import { HALApiService } from '../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const paymentsService = new CachedService(entities.Orderadmin_Accounts_Entity_Payment, '/accounts/payment', HALApiService, createItemsData)
